'use strict';

(function () {
  try {
    if (!global.Intl) {
      global.Intl = require('intl');
      require('intl/locale-data/jsonp/en.js');
      require('intl/locale-data/jsonp/zh.js');
      require('intl/locale-data/jsonp/ja.js');
    }

    if (!Intl.getCanonicalLocales) {
      require('@formatjs/intl-getcanonicallocales/polyfill');
    }

    if (!Intl.PluralRules) {
      require('@formatjs/intl-pluralrules/polyfill');
      require('@formatjs/intl-pluralrules/dist/locale-data/en');
      require('@formatjs/intl-pluralrules/dist/locale-data/zh');
      require('@formatjs/intl-pluralrules/dist/locale-data/ja');
    }

    if (!Intl.RelativeTimeFormat) {
      require('@formatjs/intl-relativetimeformat/polyfill');
      require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
      require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
      require('@formatjs/intl-relativetimeformat/dist/locale-data/ja');
    }

    if (!Intl.ListFormat) {
      require('@formatjs/intl-listformat/polyfill');
      require('@formatjs/intl-listformat/dist/locale-data/en');
      require('@formatjs/intl-listformat/dist/locale-data/zh');
      require('@formatjs/intl-listformat/dist/locale-data/ja');
    }

    if (!Intl.DisplayNames) {
      require('@formatjs/intl-displaynames/polyfill');
      require('@formatjs/intl-displaynames/dist/locale-data/en');
      require('@formatjs/intl-displaynames/dist/locale-data/zh');
      require('@formatjs/intl-displaynames/dist/locale-data/ja');
    }

    require('@formatjs/intl-numberformat/polyfill');
    require('@formatjs/intl-numberformat/dist/locale-data/en');
    require('@formatjs/intl-numberformat/dist/locale-data/zh');
    require('@formatjs/intl-numberformat/dist/locale-data/ja');

    // require('@formatjs/intl-datetimeformat/polyfill');
    // require('@formatjs/intl-datetimeformat/dist/add-golden-tz.js');
    // require('@formatjs/intl-datetimeformat/dist/locale-data/en');
    // require('@formatjs/intl-datetimeformat/dist/locale-data/zh');
    // require('@formatjs/intl-datetimeformat/dist/locale-data/ja');

    require('@formatjs/intl-locale/polyfill');
  } catch (ex) {
    console.log(ex);
  }
})();